import { NAME_FIELD_LABEL } from '../event-hubs.text';
import { plainText } from '../../../modules/validators';
import { trimSpacesLeft } from '../../../modules/formatters';
import { FormVmItemConfigType } from '../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../infrastructure/utils/form-config.utils';

export enum EventHubFormField {
    EVENT_HUB_NAME = 'eventHubName',
}

export const FORM_CONFIG = {
    [EventHubFormField.EVENT_HUB_NAME]: {
        labelDescriptor: NAME_FIELD_LABEL,
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    }
};

export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);